import { createSlice } from "@reduxjs/toolkit";
import { addPickUpAddress, getAddressDetails } from "../thunks/setAddressThunk";
import { handleRegistrationStatus } from "../../utils/registrationHelper";
const initialState = {
  isAddressLoading: false,
  isAddressErr: null,
};

const setAddressSlice = createSlice({
  name: "pickUpAdd",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addPickUpAddress.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(addPickUpAddress.fulfilled, (state, action) => {
        (((state.isAddressLoading = false), (state.action = action.payload)),
          handleRegistrationStatus(action.payload));
      })
      .addCase(addPickUpAddress.rejected, (state) => {
        state.isAddressLoading = false;
      })
      .addCase(getAddressDetails.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(getAddressDetails.fulfilled, (state, action) => {
        ((state.isAddressLoading = false), (state.action = action.payload));
      })
      .addCase(getAddressDetails.rejected, (state) => {
        state.isAddressLoading = false;
      });
  },
});

export default setAddressSlice.reducer;
